/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_All_Accepted_LeadInputs */

const en_us2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything comes accepted. Change only what you don't want. You can undo until you confirm.`)
};

const pt_br2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo já vem aceito. Mude só o que não quiser. Dá para desfazer até confirmar.`)
};

const es_419_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo viene aceptado. Cambia solo lo que no quieras. Puedes deshacer hasta confirmar.`)
};

const pt_pt2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já vem tudo aceite. Muda só o que não quiseres. Podes anular até confirmares.`)
};

const fr_fr2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est accepté d'office. Change seulement ce que tu ne veux pas. Tu peux annuler jusqu'à la confirmation.`)
};

const de_de2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles ist bereits übernommen. Ändere nur, was du nicht willst. Bis zur Bestätigung kannst du alles rückgängig machen.`)
};

const it_it2_draft_all_accepted_lead = /** @type {(inputs: Draft_All_Accepted_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È già tutto accettato. Cambia solo quello che non vuoi. Puoi annullare finché non confermi.`)
};

/**
* | output |
* | --- |
* | "Everything comes accepted. Change only what you don't want. You can undo until you confirm." |
*
* @param {Draft_All_Accepted_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_all_accepted_lead = /** @type {((inputs?: Draft_All_Accepted_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_All_Accepted_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_all_accepted_lead(inputs)
	if (locale === "es-419") return es_419_draft_all_accepted_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_all_accepted_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_all_accepted_lead(inputs)
	if (locale === "de-DE") return de_de2_draft_all_accepted_lead(inputs)
	if (locale === "it-IT") return it_it2_draft_all_accepted_lead(inputs)
	return en_us2_draft_all_accepted_lead(inputs)
});
export { draft_all_accepted_lead as "draft.all_accepted_lead" }